<template>
  <Suspense>
    <NuxtPage />
    <template #fallback>
      <FullscreenLoading />
    </template>
  </Suspense>
  <UNotifications />
</template>
